import React, { forwardRef } from "react";
import get from "lodash/get";

import GenericInputField, {
  TYPES,
} from "../../../../genericInputFields/genericInputField";
import { useFormContext } from "react-hook-form";
import useAppContext from "../../../../../hooks/useAppContext";

import { StyledRichTextWrapper } from "./richTextField.style";

const RichTextField = forwardRef(({ required, maxCharacters, name }, ref) => {
  const { axios } = useAppContext();
  const {
    control,
    formState: { errors },
  } = useFormContext();
  const error = get(errors, name);

  const handleUploadImage = async (file) => {
    const formData = new FormData();
    formData.append("file", file);
    const response = await axios.post("/upload_image", formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
    return await response.data.url;
  };

  return (
    <StyledRichTextWrapper ref={ref}>
      <GenericInputField
        type={TYPES.TEXTAREA}
        control={control}
        name={name}
        required={required}
        error={error}
        maxCharacters={maxCharacters}
        handleUploadImage={handleUploadImage}
        copyPasteRestricted={false}
        disabled={false}
      />
    </StyledRichTextWrapper>
  );
});
RichTextField.displayName = "RichTextField";

export default RichTextField;
